function getDefaultApiBaseUrl(): string {
	if (typeof window !== 'undefined') {
		const { hostname, origin } = window.location;
		// Local dev: the Vite dev server serves the UI while the Go API runs on
		// :8000 (see `make admin-dev`).
		if (hostname === 'localhost' || hostname === '127.0.0.1') {
			return 'http://localhost:8000/api';
		}
		// Production: the single binary serves the UI and API on the same origin,
		// so use relative-to-origin URLs (works for any deploy domain).
		return `${origin}/api`;
	}
	return 'http://localhost:8000/api';
}

export const API_BASE_URL: string =
	(import.meta.env.VITE_API_BASE_URL as string | undefined) || getDefaultApiBaseUrl();

export const API_ROOT_URL = API_BASE_URL.replace(/\/api\/?$/, '');
